import {useContext, useState} from 'react';
import {StudentContext} from 'context/Student.context';
import UFAR_Logo_blue from 'assets/ufar-logo-blue.png';
import IMG from 'assets/profile-picture.png';
import Loading from 'components/FullScreenLoading';
//@ts-ignore
import Barcode from 'react-barcode';
import Sign from 'assets/sign.png';
import './styles.less';

const StudentCard = () => {
	const {
		state: {
			name,
			lastName,
			email,
			courseName,
			facultyName,
			flowName,
			currentStatusName,
			studentAccountingNumber,
			studentCode,
			studentLyon3Number,
			nameLatin,
			lastNameLatin,
			path,
			imagePath
		}
	} = useContext(StudentContext);

	const [error, setError] = useState(false);

	//if (!imagePath) return <Loading />;
	return (
		<div className="student-card">
			<div className="photo-wrapper">
				<div className="logo">
					<img src={UFAR_Logo_blue} alt="UFAR_Logo_blue" width="100rem" style={{marginRight: 14}} />
				</div>
				<div className="photo">
					<img
						src={error ? IMG : process.env.REACT_APP_API_URL + '/' + path}
						onError={() => setError(true)}
						alt="USER Image"
						width="90%"
						height="100%"
					/>
				</div>
				<div className="sign">
					<div className="recteur-wrapper">
						<span>Ռեկտոր</span>
						<span>Recteur</span>
					</div>
					<div>
						<img src={Sign} style={{maxWidth: 50}} width="100%" />
					</div>
				</div>
			</div>
			<div className="content-wrapper">
				<div className="title">ՈՒՍԱՆՈՂԱԿԱՆ ՏՈՄՍ</div>
				<div className="title">CARTE d&apos;ÉTUDAIANT</div>
				<div className="id">{studentCode}</div>
				<div className="name">
					{name} {lastName}
				</div>
				<div className="name">
					{nameLatin} {lastNameLatin}
				</div>
				<div className="id">{studentAccountingNumber}</div>
				<div className="rector">
					<span>Պրոֆ․ Բերտրան Վենար</span>
					<span>Pr. Bertrand Venard</span>
				</div>
			</div>
			<div className="barcode-wrapper">
				<div className="barcode">
					<Barcode
						value={studentCode}
						displayValue={false}
						background={'transparent'}
						height={80}
						width={2.5}
					/>
				</div>
			</div>
		</div>
	);
};

export default StudentCard;
